'use strict';

export { default } from './printView.container';